import { render, staticRenderFns } from "./SentimentVguard.vue?vue&type=template&id=9915c5c6&scoped=true"
import script from "./SentimentVguard.vue?vue&type=script&lang=js"
export * from "./SentimentVguard.vue?vue&type=script&lang=js"
import style0 from "./SentimentVguard.vue?vue&type=style&index=0&id=9915c5c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9915c5c6",
  null
  
)

export default component.exports